export default "__VITE_ASSET__DkmOWiRu__"